import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rejected-cancellations-report',
  templateUrl: './rejected-cancellations-report.component.html',
  styleUrls: ['./rejected-cancellations-report.component.scss']
})
export class RejectedCancellationsReportComponent implements OnInit {

    RejectionCancellationReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    serviceProviderTypeList: any = []
    filteredList1: any = []
    LoginRoleId: any;
    sessionDataString: any;
    userListUnEncryptedCustReport: string[];
    serviceQueue: any = []
    applicationStatusTypeList: any;
    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private lookupDataService: LookupDataServiceService
    ) {
    }


    ngOnInit(): void {
        this.init()
    }
    init() {
        this.RejectionCancellationReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
        });
    }
    Reset() {
        this.RejectionCancellationReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.RejectionCancellationReportForm.controls["startDate"].value;
    }
    generateExcel() {
        debugger
         if (!this.RejectionCancellationReportForm.value.startDate && !this.RejectionCancellationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.RejectionCancellationReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.RejectionCancellationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.RejectionCancellationReportForm.value.startDate > this.RejectionCancellationReportForm.value.endDate) {
         if (this.RejectionCancellationReportForm.value.endDate) {

                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',

                })
            }
        }
        else {
            // Swal.fire({
            //     icon: 'info',
            //     title: 'Please wait while the document is being prepared for reading',
            //     showConfirmButton: true,
            //     position: 'center',
            //     timer: 6000
            // })
            this.reportService.getRejectCancellationReport(this.RejectionCancellationReportForm.value).subscribe( (data)=> {

                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'Rejected Cancellation Report.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }

            });
        }
    }
}
